<template>
  <div class="hdr">
    <div class="hdr__ttl-box">
      <transition name="animation-arrow-fade">
        <div class="hdr__arrow-box" @click="toClose()" v-if="isCoinSearchOpened">
          <ArrowIcon class="hdr__arrow" />
        </div>
      </transition>
      <span class="hdr__ttl" v-text="!isCoinSearchOpened ? 'Портфель' : 'Добавить активы'"></span>
    </div>
    <transition name="animation-cross-opacity">
      <div class="hdr__cross-box" v-if="!isCoinSearchOpened" @click="close()">
        <CrossIcon class="hdr__cross" />
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { useBriefcaseState } from '@/Groups/Briefcase/private/composables/computedValues';
  import { useBriefcaseDropdown } from '@/Groups/Briefcase/private/imports/toggleDropdown';
  //------------------------
  import CrossIcon from '@/Groups/Briefcase/private/svg/CrossIcon.vue';
  import ArrowIcon from '@/Groups/Briefcase/private/svg/ArrowIcon.vue';
  //------------------------
  const store = useStore();
  //------------------------
  const { isCoinSearchOpened } = useBriefcaseState();
  //------------------------
  const { close } = useBriefcaseDropdown();
  //------------------------
  const toClose = () => store.dispatch('Briefcase/toggleSearchSection', false);
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>